const RelatedModel = require('module/user/related_model')
const products = require('data/products')

const Product = RelatedModel.extend({

    defaults: {
        id: '',
        type: '',
        title: '',
        description: '',
        name: '',
        price: null,
        coupon: null,
    },

    initialize(attrs, options) {
        RelatedModel.prototype.initialize.apply(this, arguments)

        this.checkTitle()
        this.checkPrice()
    },

    checkTitle() {
        // ensure that we have a title
        const title = this.get('title')
        if (! title) {
            this.set('title', this.getTitle())
        }
    },

    getTitle() {
        const type = this.get('type')
        switch (type) {
            case 'plan': {
                const id = this.get('id')
                const plan = products.index[id]
                const title = plan && plan.title || ''
                return title
            }
            case 'domain': {
                return this.get('domain')
            }
            default: {
                return ''
            }
        }
    },

    checkPrice() {
        // ensure that we have a price
        const price = this.get('price')
        if (typeof price !== 'number') {
            this.set('price', this.getPrice())
        }
    },

    getPrice() {
        const type = this.get('type')
        switch (type) {
            case 'plan': {
                const id = this.get('id')
                const plan = products.index[id]
                const price = plan && plan.price || 0
                return price
            }
            case 'domain': {
                // domain is assumed to be free
                // unless a price was provided
                return 0
            }
            default: {
                return 0
            }
        }
    },

    calculated_values: {
        actual_price() {
            const coupon = this.get('coupon')
            let price = this.get('price')
            if (! coupon) return price
            if (! coupon.valid) return price

            switch (coupon.type) {
                case 'percent_off': {
                    const percent = coupon.value / 100
                    price = price - (price * percent)
                    break
                }
                case 'amount_off': {
                    price = price - coupon.value
                    break
                }
                case 'no_cc_required': {
                    price = 0
                    break
                }
                case 'trial_period': {
                    price = 0
                    break
                }
                default: {
                    break
                }
            }

            return price
        },

        discounted() {
            const price = this.get('price')
            const actual_price = this.get('actual_price')
            return (price !== actual_price)
        },
    },

})

module.exports = Product
